import React from 'react';
import './Heading.scss';
import { ReactComponent as EditIcon } from '@/assets/img/edit-icon-new-v2.svg';

export type HeadingProps = {
  size?: 'sm' | 'lg';
  alignText?: 'left' | 'center';
  title?: string;
  subTitle?: string;
  description?: string;
  customeCss?: string;
  fontWeight?: string;
  isEditable?: boolean;
  onEdit?: () => void;
  defaultDesc?: string;
};

export const Heading = ({
  size,
  title,
  subTitle,
  description,
  alignText,
  customeCss,
  fontWeight,
  isEditable,
  onEdit,
  defaultDesc,
}: HeadingProps) => {
  return (
    <div className={`heading-section ${alignText} ${customeCss}`}>
      {size == 'sm'
        ? title && (
            <h6>
              {title}
              <span>
                {subTitle} {isEditable && <EditIcon onClick={onEdit} />}
              </span>
            </h6>
          )
        : title && (
            <h5 className={`${title === 'Welcome aboard!' ? 'justify-center' : ''}`}>
              {title}{' '}
              <span>
                {subTitle} {isEditable && <EditIcon onClick={onEdit} />}
              </span>
            </h5>
          )}
      <p className={fontWeight == 'sm' ? 'font-500' : ''}>
        {description ? description : defaultDesc}
      </p>
    </div>
  );
};

Heading.displayName = 'Heading';
